module.exports = __webpack_public_path__ + "img/it-it.2172117d.svg";